<script type="text/ecmascript-6">
    import DesignerQuestionHardwareColour from "../DesignerQuestionHardwareColour.vue";
    import SynsealTileQuestion from "../mixin/synseal/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareColour,
            SynsealTileQuestion,
        ],
        props: {
            is_craftsman: {
                required: true,
            },
            sbd: {
                required: true,
            }
        },
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/hardware-colour?slab=' + this.slab + '&secured_by_design=' + this.sbd + '&opening_direction=' + this.openingDirection + '&door_range=' + this.doorRange + '&profile=' + this.profile;
            },
            filtered_option_list(){
                if (this.option_list === null) {
                    return [];
                }

                if (!Array.isArray(this.option_list)) {
                    return [];
                }

                return this.option_list.filter((key)=> {
                    return key.value !== null && !!key.value;
                });
            },
            cache_key(){
                return '_' + this.slab + '_' + this.sbd;
            },
        },
        watch: {
            'sbd': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
